"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es6");
require("core-js/es7/reflect");
require('zone.js/dist/zone');
if (process.env.ENV === 'production') {
    // Production
}
else {
    // Development and test
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}
if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector;
if (!Element.prototype.closest)
    Element.prototype.closest = function (selector) {
        var el = this;
        while (el) {
            if (el.matches(selector)) {
                return el;
            }
            el = el.parentElement;
        }
    };



//////////////////
// WEBPACK FOOTER
// ./src/polyfills.ts
// module id = 1335
// module chunks = 2